<template>
  <div
    class="application-toolbar"
    :class="[isZkm ? 'application-toolbar-zkm' : 'application-toolbar']"
  >
    <div :class="[isZkm ? 'zkm-logo' : '']">
      <button v-if="isZkm" class="back-button-zkm" @click="backButtonZkm()">
        <v-icon :color="'black'" dark> arrow_back</v-icon>
        <p>{{ $t('backToZkm') }}</p>
      </button>
      <button v-if="!hideLogo" @click="goToMainPage">
        <v-toolbar-title class="toolbar-title">
          <img src="/assets/core-event-blue.png" alt="CoreEvent logo" />
        </v-toolbar-title>
      </button>
    </div>
    <v-spacer v-if="!isZkm" />
    <div :class="[isZkm ? 'header-right-container-zkm' : 'header-right-container']">
      <div
        v-if="user && !user.isVerifiedByCoreEvent && !hideProAccountButton"
        class="demo-badge"
        @click="demoModal = true"
      >
        Get Pro Account
      </div>
      <div
        v-if="user && (user.type === 'REGULAR' || user.type === 'TRIAL')"
        class="show-modal-button"
      >
        <img alt="Bell" src="/assets/notification-icon.svg" @click="handleShowModal()" />
        <div v-if="!user.hasSeenOnboarding" class="onboarding-dot" />
      </div>
      <language-switcher :event-slug="slug" :is-zkm="isZkm" />
      <v-toolbar-items v-if="user" class="toolbar-items">
        <v-menu v-model="menu" offset-y nudge-bottom="24">
          <v-btn
            slot="activator"
            :ripple="false"
            large
            flat
            style="magin-right: 36px"
            :class="['pa-0 user-button', menu && 'expanded']"
          >
            <v-icon :color="menu ? '#0277BD' : 'black'" dark> account_circle</v-icon>
            <span class="user-name" :style="menu && 'color: #0277BD;'"> {{ user.firstName }}</span>
            <v-icon class="material-icons" :color="menu ? '#0277BD' : 'black'">
              expand_more
            </v-icon>
          </v-btn>
          <v-list class="header-menu">
            <v-list-tile
              v-if="!['TICKET_SELLER', 'TICKET_SELLER_ADMIN'].includes(user.type)"
              @click="goToMyTickets"
            >
              <img alt="Tickets" src="/assets/your-tickets.svg" />
              <v-list-tile-title class="list-item-title"> Your tickets</v-list-tile-title>
            </v-list-tile>
            <v-list-tile
              v-if="!['TICKET_SELLER', 'TICKET_SELLER_ADMIN', 'EVENT_WORKER'].includes(user.type)"
              :to="{
                name: routes.organizer.organizations,
              }"
            >
              <img alt="Events" src="/assets/your-events.svg" />
              <v-list-tile-title class="list-item-title">Your Organizations</v-list-tile-title>
            </v-list-tile>
            <v-list-tile
              :to="{
                name: routes.shared.userProfile,
              }"
            >
              <img alt="Account" src="/assets/your-account.svg" />
              <v-list-tile-title class="list-item-title"> Your account</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="onLogout()">
              <img alt="Logout" src="/assets/logout.svg" />
              <v-list-tile-title class="list-item-title"> Logout</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-toolbar-items>
      <div v-else>
        <main-button
          v-if="location === '/login'"
          text="Sign Up"
          depressed
          @click="goTo(routes.shared.signUp, { redirectUrl })"
        />
        <main-button
          v-if="location === '/sign-up'"
          text="Log In"
          depressed
          @click="goTo(routes.shared.login, { redirectUrl })"
        />
      </div>
    </div>
    <onboarding-modal v-if="showModal" @closeModal="handleCloseModal()" />
    <complete-registration-modal
      v-if="showCompleteRegistrationModal"
      ref="completeRegModal"
      :user="user"
      @submit="updateUserInfo($event)"
    />
    <simple-snackbar
      :open.sync="snackbarOpen"
      :message-prop="snackbarMessage"
      :color="snackbarColor"
    />
    <demo-modal v-if="demoModal" :user="user" @close="demoModal = false" />
  </div>
</template>

<script>
import { logout } from '../../http'
import {
  GET_LOGGED_USER,
  UPDATE_USER,
  USER_HAS_FINISHED_ONBOARDING,
} from '../../graphql/user.graphql'
import { customerURL, landingURL, zkmURL } from '../../utils'
import { GET_APPLICATION_HEADER_DATA } from '../../graphql/event.graphql'
import LanguageSwitcher from '../shared/language-switcher.vue'
import onboardingModal from './onboarding/onboarding-modal.vue'
import completeRegistrationModal from './complete-registration-modal.vue'
import { GoogleAuth } from '@/types'
import SimpleSnackbar from '../shared/snackbars/simple-snackbar.vue'
import DemoModal from '@/components/organizations/DemoModal.vue'

export default {
  name: 'application-header',
  components: {
    DemoModal,
    LanguageSwitcher,
    onboardingModal,
    completeRegistrationModal,
    SimpleSnackbar,
  },
  data() {
    let slug = null

    try {
      if (window.location.href.includes('custom-register')) {
        slug = decodeURIComponent(
          window.location.href.match(new RegExp('(?<=events/).*?(?=/custom-register)'))[0],
        )
      } else if (window.location.href.includes('register')) {
        slug = decodeURIComponent(
          window.location.href.match(new RegExp('(?<=events/).*?(?=/register)'))[0],
        )
      }
    } catch (e) {
      console.error(e)
    }

    return {
      user: null,
      menu: false,
      location: document.location.hash,
      hideNav: false,
      redirectUrl: '',
      slug: slug,
      hideLogo: true,
      showModal: false,
      showCompleteRegistrationModal: false,
      event: null,
      snackbarOpen: false,
      snackbarMessage: '',
      snackbarColor: '',
      demoModal: false,
    }
  },

  computed: {
    skipQuery() {
      this.hideLogo = false

      return !window.location.href.includes('/register') || !this.slug
    },
    isZkm() {
      return false
    },
    hideProAccountButton() {
      // Vue router no longer passes meta from parent routes to child routes so we need to check all the matched routes
      return this.$route.matched.some(m => m.meta.hideProAccountButton)
    },
  },
  watch: {
    async $route() {
      const { data = {} } = await this.getUser()
      const { me: user } = data || {}
      this.user = user
      this.location = document.location.hash
    },
  },
  beforeMount() {
    const query = location.href.substring(location.href.indexOf('?'))
    const queryParams = new URLSearchParams(query)
    if (queryParams.has('redirect_url')) {
      this.redirectUrl = decodeURIComponent(queryParams.get('redirect_url'))
      this.goTo(this.routes.shared.login, { redirectUrl: this.redirectUrl })
    }
  },
  apollo: {
    me: {
      query: GET_LOGGED_USER,
      async result({ data, loading }) {
        if (!loading && data) {
          const { me: user } = data
          this.user = user

          if (
            this.user &&
            (this.user.type === 'REGULAR' || this.user.type === 'TRIAL') &&
            !this.user.hasSeenOnboarding &&
            this.$route.name !== 'register'
          ) {
            if (!this.user.firstName || !this.user.lastName) {
              this.showCompleteRegistrationModal = true
            }

            this.showModal = true

            await this.$apollo.mutate({
              mutation: USER_HAS_FINISHED_ONBOARDING,
              refetchQueries: ['getLoggedUser'],
            })
          }
        }
      },
    },
    getApplicationHeaderData: {
      query: GET_APPLICATION_HEADER_DATA,
      variables() {
        return {
          slug: this.slug,
        }
      },
      skip() {
        return this.skipQuery
      },
      async result({ loading, data }) {
        if (!loading && data) {
          const { getApplicationHeaderData: event } = data
          this.event = event
          try {
            this.hideLogo = event.eventUtils.inviteFormStyles.workshopsForm.hideLogo
          } catch (e) {
            this.hideLogo = false
          }
        }
      },
    },
  },
  created() {
    window.addEventListener('resize', this.resizeHandler)
    if (window.innerWidth > 800) {
      this.hideNav = true
    }
  },
  destroyed() {
    window.removeEventListener('resize', this.resizeHandler)
  },
  mounted() {
    if (!window.gapi.auth2) {
      window.gapi.load('auth2', function () {
        window.gapi.auth2.init({
          clientId: GoogleAuth.CLIENT_ID,
          plugin_name: GoogleAuth.PLUGIN_NAME,
        })
      })
    }
  },
  methods: {
    handleShowModal() {
      this.showModal = true
    },
    handleCloseModal() {
      this.showModal = false
    },
    async getUser() {
      return this.$apollo.query({
        query: GET_LOGGED_USER,
      })
    },
    async updateUserInfo(userInfo) {
      const { errors } = await this.$apollo.mutate({
        mutation: UPDATE_USER,
        variables: { userInfo },
        refetchQueries: [{ query: GET_LOGGED_USER }],
      })
      if (errors) {
        this.snackbarMessage = errors[0].message
        this.snackbarColor = 'red'
        this.snackbarOpen = true
      } else {
        this.$refs.completeRegModal.loading = false
        this.showCompleteRegistrationModal = false
        this.snackbarMessage = 'Registration successfully completed!'
        this.snackbarColor = 'primary'
        this.snackbarOpen = true
      }
    },
    async onLogout() {
      await this.googleSignOut()
      await logout()
      await this.$apolloProvider.defaultClient.cache.reset()
      this.goTo(this.routes.shared.login)
    },
    googleSignOut() {
      let auth2 = window.gapi.auth2.getAuthInstance()
      auth2.signOut().then(() => {
        console.log('User signed out')
        this.profile = null
      })
    },
    resizeHandler() {
      this.hideNav = window.innerWidth > 800
    },
    goToMyTickets() {
      window.location.href = `${customerURL}`
    },
    goToMainPage() {
      if (
        this.$route.name === this.routes.shared.register ||
        this.$route.name === this.routes.organizer.successfulPayment
      ) {
        window.location.href = this.isZkm ? 'https://www.zekaem.hr/' : `${landingURL}`
      } else {
        if (!this.user) {
          if (this.$route.name !== this.routes.shared.login) {
            this.goTo(this.routes.shared.login)
          }
        } else {
          if (this.user.type === 'TICKET_SELLER') {
            this.goTo(this.routes.main.ticketSellerSidebar)
          } else if (this.user.type === 'TICKET_SELLER_ADMIN') {
            this.goTo(this.routes.ticketSellerAdmin.reportsAdmin)
          } else {
            this.goTo(this.routes.organizer.organizations)
          }
        }
      }
    },
    backButtonZkm() {
      window.location.href = `${zkmURL}/raspored/`
    },
  },
}
</script>

<style scoped>
.zkm-logo {
  display: flex;
}

.back-button-zkm {
  display: flex;
  margin-right: 2.75rem;
  align-items: center;
  @media only screen and (max-width: 620px) {
    margin-right: 1rem;
  }
}

.back-button-zkm p {
  margin-left: 1rem;
  margin-bottom: 0 !important;
  font-weight: 600;
  font-size: 1.1rem;

  @media only screen and (max-width: 620px) {
    display: none;
  }
}

.button-no-background {
  background: #0277bd;
  border-radius: 18px;
  flex: none;
  order: 0;
  align-self: center;
  margin: 0px 10px;
}

.header-right-container {
  display: flex;
  flex-direction: row;
  gap: 0.25rem;
  align-items: center;
  justify-content: center;
}

.header-right-container-zkm {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.header-menu {
  width: 213px;
  padding: 0 !important;
}

.list-item-title {
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  font-feature-settings: 'pnum' on, 'lnum' on;
  color: #0277bd;
  margin-left: 0.875rem;
}

.application-toolbar {
  width: 100%;
  height: 5rem;
  background-color: white !important;
  color: black;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 1rem;
  margin-bottom: 2.5rem;
}

.application-toolbar-zkm {
  width: 100%;
  height: 5rem;
  background-color: white !important;
  color: black;
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1440px;
  margin: 0 auto;
  margin-bottom: 2.5rem;
}

.toolbar-items span {
  height: 24px;
  font-size: 16px;
  font-family: 'Raleway', sans-serif;
  font-weight: bold;
  text-align: right;
  color: black;
}

.toolbar-title {
  line-height: 0;
}

.toolbar-title img {
  height: 40px;
}

.user-button {
  width: auto;
  height: 40px !important;
  padding: 0 5px !important;
  border-radius: 20px;
  min-width: unset !important;
}

.user-button.v-btn--active::before,
.user-button.v-btn:focus::before,
.user-button.v-btn:hover::before {
  background: transparent;
}

.expanded {
  background: #e6f1f8;
}

.user-name {
  text-transform: none;
  margin-right: 4px;
  margin-left: 10px;
}

.show-modal-button {
  position: relative;
  display: flex;
  padding: 4px;
  border-radius: 50%;
}

.show-modal-button img {
  filter: invert(39%) sepia(5%) saturate(0%) hue-rotate(138deg) brightness(99%) contrast(92%);
}

.show-modal-button:hover {
  background-color: #f5f5f5;
  cursor: pointer;
}

.show-modal-button:active {
  background-color: #004c8c;
  cursor: pointer;
}

.show-modal-button:active img {
  filter: invert(100%) sepia(0%) saturate(2388%) hue-rotate(351deg) brightness(112%) contrast(101%);
}

.onboarding-dot {
  height: 6px;
  width: 6px;
  background-color: #56a4ef;
  position: absolute;
  border-radius: 50%;
  top: 3px;
  right: 3px;
}

.demo-badge {
  cursor: pointer;
  display: flex;
  justify-items: center;
  background-color: #fceae6;
  color: #ff4c00;
  border: 1px solid #ff4c00;
  border-radius: 22px;
  padding: 8px;
  white-space: nowrap;
}
</style>
